module.exports = __webpack_public_path__ + "img/DE00699.980b0cd7.png";